
import './Transactions.css';
import { HeaderActivityIndicator } from '../activityIndicator/ActivityIndicator';
import Pet from '../pet/Pet';
import {
  getMagmicCoinPrice,
  getMagmicCoinPriceForString,
  shelterNameForId,
  titleForShelterId,
  imageURLForAsset,
  rarityNameFor,
  iconURLForSpecialty } from '../../assetHelpers';
import imageMagmicCoin from './../../../images/magmic_coin.png';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import ReactGA from "react-ga4";

export const MarketplaceBuyForm = (props) => {

  const marketplaceTransactionItem = props.marketplaceTransactionItem;
  const petName = marketplaceTransactionItem.pet ? marketplaceTransactionItem.pet.name : undefined;
  const priceMC = getMagmicCoinPrice(marketplaceTransactionItem);

  const [transactionPending, setTransactionPending] = useState(false);
  const [transactionComplete, setTransactionComplete] = useState(false);
  const [transactionErrorMessage, setTransactionErrorMessage] = useState(undefined);

  const userReduxStore = useSelector(state => {
    return state.user;
  });

  const buy = () => {

    if (!userReduxStore.braincloudSession.sessionId) {
      console.error("Marketplace buy request ignored. UserReduxStore braincloudSession not found.");
      return;
    }

    const sessionId = userReduxStore.braincloudSession.sessionId;
    const transactionId = marketplaceTransactionItem.id;

    setTransactionPending(true);

    // Simple POST request with a JSON body using fetch
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        sessionId: sessionId,
        transactionId: transactionId
      })
    };
    let apiEndpointURL = "";
    switch (process.env.REACT_APP_ENV) {
      case "staging":
        apiEndpointURL = "https://cf35m63tng.execute-api.us-east-1.amazonaws.com/test/marketplace/buy";
        break;
      default:
        apiEndpointURL = "https://q645yqsbml.execute-api.us-east-1.amazonaws.com/prod/marketplace/buy";
        break;
    }

    fetch(apiEndpointURL, requestOptions)
      .then(response => response.json())
      .then(data => {
        setTransactionPending(false);
        const success = data.response && data.response.success ? true : false;
        if (success) {
          if (!window.location.href.startsWith("http://localhost")) {
            let petParams;
            if ( marketplaceTransactionItem.pet) {
              petParams = {
                ownerId: marketplaceTransactionItem.pet.ownerId,
                visualId: marketplaceTransactionItem.pet.visualId,
                rarity: marketplaceTransactionItem.pet.rarity,
                name: marketplaceTransactionItem.pet.name,
                classification: marketplaceTransactionItem.pet.classification,
                specialty: marketplaceTransactionItem.pet.specialty,
                level: marketplaceTransactionItem.pet.level,
                bonus: marketplaceTransactionItem.pet.bonus,
                id: marketplaceTransactionItem.pet.id,
                price: marketplaceTransactionItem.priceNumber,
                type: "marketplace"
              }
            }
            ReactGA.event(
              "purchase_pet",
              petParams
            );
          }

          setTransactionComplete(true);
        } else {
          setTransactionErrorMessage("Error: " + (data.response && data.response.errorMessage ? data.response.errorMessage : "Unknown error."));
        }
      });
  };

  if (transactionErrorMessage) {
    return (
      <>
      <div className="marketplaceModal">
        <p>
         {transactionErrorMessage}
        </p>
        <div className="actions">
          <button className="cancel" onClick={props.onDismiss}>Close</button>
        </div>
      </div>
      </>
    )
  }
  if (transactionComplete) {
    return (
      <>
      <div className="marketplaceModal">
        <p>
         Purchased complete!
        </p>
        <div className="actions">
          <button className="buy" onClick={props.onSuccess}>Close</button>
        </div>
      </div>
      </>
    )
  }

  return (
    <>
    <HeaderActivityIndicator isLoading={transactionPending} />
    <div className="marketplaceModal">
      <p>
      Do you want to purchase {petName} for <img className="currency" src={imageMagmicCoin} />{priceMC}?
      </p>
      <div className="actions">
        <button disabled={transactionPending} className="cancel" onClick={props.onDismiss}>Cancel</button>
        <button disabled={transactionPending} className="buy" onClick={buy}>Buy</button>
      </div>
    </div>
    </>
  )
}

export const MarketplaceBuyLimitedPetForm = (props) => {

  const limitedPetData = props.limitedPetData;
  const bundleId = limitedPetData.id; // "id": "2021_08_limited_unicorn"
  const bundleName = shelterNameForId(bundleId); // Farmer
  const priceMC = getMagmicCoinPriceForString(limitedPetData.price);

  const [purchasedPetData, setPurchasedPetData] = useState(undefined);
  const [transactionPending, setTransactionPending] = useState(false);
  const [transactionComplete, setTransactionComplete] = useState(false);
  const [transactionErrorMessage, setTransactionErrorMessage] = useState(undefined);

  const userReduxStore = useSelector(state => {
    return state.user;
  });

  const buy = () => {

    if (!userReduxStore.braincloudSession.sessionId) {
      console.error("Marketplace buy limited pet request ignored. UserReduxStore braincloudSession not found.");
      return;
    }

    const sessionId = userReduxStore.braincloudSession.sessionId;

    setTransactionPending(true);

    // Simple POST request with a JSON body using fetch
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        sessionId: sessionId,
        bundleId: bundleId
      })
    };
    let apiEndpointURL = "";
    switch (process.env.REACT_APP_ENV) {
      case "staging":
        apiEndpointURL = "https://cf35m63tng.execute-api.us-east-1.amazonaws.com/test/marketplace/buylimitedpet";
        break;
      default:
        apiEndpointURL = "https://q645yqsbml.execute-api.us-east-1.amazonaws.com/prod/marketplace/buylimitedpet";
        break;
    }

    fetch(apiEndpointURL, requestOptions)
      .then(response => response.json())
      .then(data => {
        setTransactionPending(false);
        const success = data.response && data.response.success ? true : false;
        const petData = data.response && data.response.pet ? data.response.pet : undefined;
        if (success) {
          setPurchasedPetData(petData);
          if (!window.location.href.startsWith("http://localhost")) {
            let petParams;
            if ( petData) {
              petParams = {
                ownerId: petData.ownerId,
                visualId: petData.visualId,
                rarity: petData.rarity,
                name: petData.name,
                classification: petData.classification,
                specialty: petData.specialty,
                level: petData.level,
                bonus: petData.bonus,
                id: petData.id,
                price: Number(limitedPetData.price),
                type: "limited"
              }
            }
            ReactGA.event(
              "purchase_pet",
              petParams
            );
          }
          setTransactionComplete(true);
        } else {
          setTransactionErrorMessage("Error: " + (data.response && data.response.errorMessage ? data.response.errorMessage : "Unknown error."));
        }
      });
  };

  if (transactionErrorMessage) {
    return (
      <>
      <div className="marketplaceModal">
        <p>
         {transactionErrorMessage}
        </p>
        <div className="actions">
          <button className="cancel" onClick={props.onDismiss}>Close</button>
        </div>
      </div>
      </>
    )
  }
  if (transactionComplete) {
    return (
      <>
      <div className="marketplaceModal">
        {purchasedPetData ?
          <>
          <p>Purchase complete!</p>
          <div className="purchasedPetWrapper">
            <div className="marketplaceResults">
              <div className="assetSummary">
                <Pet pet={purchasedPetData} />
              </div>
            </div>
          </div>
          </>
        :
          <p>
          Purchase complete! 
          </p>
        }
        <div className="actions">
          <button className="buy" onClick={props.onSuccess}>Close</button>
        </div>
      </div>
      </>
    )
  }

  return (
    <>
    <HeaderActivityIndicator isLoading={transactionPending} />
    <div className="marketplaceModal">
      <p>
      Do you want to purchase {bundleName} for <img className="currency" src={imageMagmicCoin} />{priceMC}?
      </p>
      <div className="actions">
        <button disabled={transactionPending} className="cancel" onClick={props.onDismiss}>Cancel</button>
        <button disabled={transactionPending} className="buy" onClick={buy}>Buy</button>
      </div>
    </div>
    </>
  )
}

export const MarketplaceBuyRotatingPetForm = (props) => {

  const rotatingPetData = props.rotatingPetData;
  const bundleId = rotatingPetData.id; // "id": "2021_08_limited_unicorn"

  const petName = rotatingPetData.pet ? rotatingPetData.pet.name : undefined;
  const priceMC = getMagmicCoinPriceForString(rotatingPetData.price);

  const [purchasedPetData, setPurchasedPetData] = useState(undefined);
  const [transactionPending, setTransactionPending] = useState(false);
  const [transactionComplete, setTransactionComplete] = useState(false);
  const [transactionErrorMessage, setTransactionErrorMessage] = useState(undefined);

  const userReduxStore = useSelector(state => {
    return state.user;
  });

  const buy = () => {

    if (!userReduxStore.braincloudSession.sessionId) {
      console.error("Marketplace buy rotating pet request ignored. UserReduxStore braincloudSession not found.");
      return;
    }

    const sessionId = userReduxStore.braincloudSession.sessionId;

    setTransactionPending(true);

    // Simple POST request with a JSON body using fetch
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        sessionId: sessionId,
        bundleId: bundleId
      })
    };
    let apiEndpointURL = "";
    switch (process.env.REACT_APP_ENV) {
      case "staging":
        apiEndpointURL = "https://cf35m63tng.execute-api.us-east-1.amazonaws.com/test/marketplace/buyrotatingpet";
        break;
      default:
        apiEndpointURL = "https://q645yqsbml.execute-api.us-east-1.amazonaws.com/prod/marketplace/buyrotatingpet";
        break;
    }

    fetch(apiEndpointURL, requestOptions)
      .then(response => response.json())
      .then(data => {
        setTransactionPending(false);
        const success = data.response && data.response.success ? true : false;
        const petData = data.response && data.response.pet ? data.response.pet : undefined;
        if (success) {
          if (!window.location.href.startsWith("http://localhost")) {
            let petParams;
            if ( petData) {
              petParams = {
                ownerId: petData.ownerId,
                visualId: petData.visualId,
                rarity: petData.rarity,
                name: petData.name,
                classification: petData.classification,
                specialty: petData.specialty,
                level: petData.level,
                bonus: petData.bonus,
                id: petData.id,
                price: Number(rotatingPetData.price),
                type: "rotating"
              }
            }
            ReactGA.event(
              "purchase_pet",
              petParams
            );
          }
          setPurchasedPetData(petData);
          setTransactionComplete(true);
        } else {
          setTransactionErrorMessage("Error: " + (data.response && data.response.errorMessage ? data.response.errorMessage : "Unknown error."));
        }
      });
  };

  if (transactionErrorMessage) {
    return (
      <>
      <div className="marketplaceModal">
        <p>
         {transactionErrorMessage}
        </p>
        <div className="actions">
          <button className="cancel" onClick={props.onDismiss}>Close</button>
        </div>
      </div>
      </>
    )
  }
  if (transactionComplete) {
    return (
      <>
      <div className="marketplaceModal">
        {purchasedPetData ?
          <>
          <p>Purchase complete!</p>
          <div className="purchasedPetWrapper">
            <div className="marketplaceResults">
              <div className="assetSummary">
                <Pet pet={purchasedPetData} />
              </div>
            </div>
          </div>
          </>
        :
          <p>
          Purchase complete! 
          </p>
        }
        <div className="actions">
          <button className="buy" onClick={props.onSuccess}>Close</button>
        </div>
      </div>
      </>
    )
  }

  return (
    <>
    <HeaderActivityIndicator isLoading={transactionPending} />
    <div className="marketplaceModal">
      <p>
      Do you want to purchase {petName} for <img className="currency" src={imageMagmicCoin} />{priceMC}?
      </p>
      <div className="actions">
        <button disabled={transactionPending} className="cancel" onClick={props.onDismiss}>Cancel</button>
        <button disabled={transactionPending} className="buy" onClick={buy}>Buy</button>
      </div>
    </div>
    </>
  )
}

export const MarketplaceBuyGachaLotteryForm = (props) => {

  const gachaPetData = props.gachaPetData;
  const bundleId = gachaPetData.id; // "id": "gacha_farmer"
  const bundleName = titleForShelterId(bundleId); // Farmer
  const priceMC = getMagmicCoinPriceForString(gachaPetData.price);

  const [purchasedPetData, setPurchasedPetData] = useState(undefined);
  const [transactionPending, setTransactionPending] = useState(false);
  const [transactionComplete, setTransactionComplete] = useState(false);
  const [transactionErrorMessage, setTransactionErrorMessage] = useState(undefined);

  const userReduxStore = useSelector(state => {
    return state.user;
  });

  const buy = () => {

    if (!userReduxStore.braincloudSession.sessionId) {
      console.error("Marketplace buy gacha lottery request ignored. UserReduxStore braincloudSession not found.");
      return;
    }

    const sessionId = userReduxStore.braincloudSession.sessionId;

    setTransactionPending(true);

    // Simple POST request with a JSON body using fetch
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        sessionId: sessionId,
        bundleId: bundleId
      })
    };
    let apiEndpointURL = "";
    switch (process.env.REACT_APP_ENV) {
      case "staging":
        apiEndpointURL = "https://cf35m63tng.execute-api.us-east-1.amazonaws.com/test/marketplace/buygachalottery";
        break;
      default:
        apiEndpointURL = "https://q645yqsbml.execute-api.us-east-1.amazonaws.com/prod/marketplace/buygachalottery";
        break;
    }

    fetch(apiEndpointURL, requestOptions)
      .then(response => response.json())
      .then(data => {
        setTransactionPending(false);
        const success = data.response && data.response.success ? true : false;
        const petData = data.response && data.response.pet ? data.response.pet : undefined;
        if (success) {
          setPurchasedPetData(petData);
          setTransactionComplete(true);
        } else {
          setTransactionErrorMessage("Error: " + (data.response && data.response.errorMessage ? data.response.errorMessage : "Unknown error."));
        }
      });
  };

  if (transactionErrorMessage) {
    return (
      <>
      <div className="marketplaceModal">
        <p>
         {transactionErrorMessage}
        </p>
        <div className="actions">
          <button className="cancel" onClick={props.onDismiss}>Close</button>
        </div>
      </div>
      </>
    )
  }
  if (transactionComplete) {
    return (
      <>
      <div className="marketplaceModal">
        {purchasedPetData ?
          <>
          <p>Purchase complete!</p>
          <div className="purchasedPetWrapper">
            <div className="marketplaceResults">
              <div className="assetSummary">
                <Pet pet={purchasedPetData} />
              </div>
            </div>
          </div>
          </>
        :
          <p>
          Purchase complete! 
          </p>
        }
        <div className="actions">
          <button className="buy" onClick={props.onSuccess}>Close</button>
        </div>
      </div>
      </>
    )
  }

  return (
    <>
    <HeaderActivityIndicator isLoading={transactionPending} />
    <div className="marketplaceModal">
      <p>
      Do you want to purchase {bundleName} for <img className="currency" src={imageMagmicCoin} />{priceMC}?
      </p>
      <div className="actions">
        <button disabled={transactionPending} className="cancel" onClick={props.onDismiss}>Cancel</button>
        <button disabled={transactionPending} className="buy" onClick={buy}>Buy</button>
      </div>
    </div>
    </>
  )
}

export const MarketplaceDelistForm = (props) => {

  const asset = props.asset;
  const petName = asset.name;

  const [transactionPending, setTransactionPending] = useState(false);
  const [transactionComplete, setTransactionComplete] = useState(false);
  const [transactionErrorMessage, setTransactionErrorMessage] = useState(undefined);

  const userReduxStore = useSelector(state => {
    return state.user;
  });

  const delist = () => {
    if (!userReduxStore.braincloudSession.sessionId) {
      console.error("Marketplace delist request ignored. UserReduxStore braincloudSession not found.");
      return;
    }

    const marketplaceTransactionItem = props.marketplaceTransactionItem;

    if (!marketplaceTransactionItem) {
      console.error("Marketplace delist request ignored. marketplaceTransactionItem missing.");
      return;
    }

    const sessionId = userReduxStore.braincloudSession.sessionId;
    
    const transactionId = marketplaceTransactionItem.id;

    setTransactionPending(true);

    // Simple POST request with a JSON body using fetch
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        sessionId: sessionId,
        transactionId: transactionId
      })
    };

    let apiEndpointURL = "";
    switch (process.env.REACT_APP_ENV) {
      case "staging":
        apiEndpointURL = "https://cf35m63tng.execute-api.us-east-1.amazonaws.com/test/marketplace/delist";
        break;
      default:
        apiEndpointURL = "https://q645yqsbml.execute-api.us-east-1.amazonaws.com/prod/marketplace/delist";
        break;
    }

    fetch(apiEndpointURL, requestOptions)
      .then(response => response.json())
      .then(data => {
        setTransactionPending(false);
        const success = data.response && data.response.success ? true : false;
        if (success) {
          setTransactionComplete(true);
        } else {
          setTransactionErrorMessage("Error: " + (data.response && data.response.errorMessage ? data.response.errorMessage : "Unknown error."));
        }
      });
  }
   
  if (transactionErrorMessage) {
    return (
      <>
      <div className="marketplaceModal">
        <p>
          {transactionErrorMessage}
        </p>
        <div className="actions">
          <button className="cancel" onClick={props.onDismiss}>Close</button>
        </div>
      </div>
      </>
    )
  }
  if (transactionComplete) {
    return (
      <>
      <div className="marketplaceModal">
        <p>
          Delist complete.
        </p>
        <div className="actions">
          <button className="buy" onClick={props.onSuccess}>Close</button>
        </div>
      </div>
      </>
    )
  }
  
  return (
    <>
    <HeaderActivityIndicator isLoading={transactionPending} />
    <div className="marketplaceModal">
      <p>
        Do you want to stop listing {petName} for sale in the Marketplace?
      </p>
      <div className="actions">
        <button disabled={transactionPending} className="cancel" onClick={props.onDismiss}>Cancel</button>
        <button disabled={transactionPending} className="buy" onClick={delist}>Delist</button>
      </div>
    </div>
    </>
  )
}

const MARKETPLACE_SELL_MAX_PRICE_MC = 100000;
const MARKETPLACE_SELL_MAX_PRICE_MC_LABEL = "one hundred thousand";

export const MarketplaceSellForm = (props) => {

  const asset = props.asset;

  const [priceMC, setPriceMC] = useState("");
  const [priceMCIsValid, setPriceMCIsValid] = useState(false);
  const [priceMCError, setPriceMCError] = useState("");
  const [transactionPending, setTransactionPending] = useState(false);
  const [transactionComplete, setTransactionComplete] = useState(false);
  const [transactionErrorMessage, setTransactionErrorMessage] = useState("");

  const userReduxStore = useSelector(state => {
    return state.user;
  });

  const validatePriceMC = (currentInput) => {

    if (currentInput === "") {
      return false; // return without setting any error
    }

    if (isNaN(currentInput)) {
      setPriceMCError("Please enter a number.");
      return false;
    }

    const currentInputFloat = parseFloat(currentInput);

    if (currentInputFloat <= 0) {
      return false; // return without setting any error
    }

    if (currentInputFloat > MARKETPLACE_SELL_MAX_PRICE_MC) {
      setPriceMCError("The current max limit is " + MARKETPLACE_SELL_MAX_PRICE_MC_LABEL + ".");
      return false;
    }

    // enforce a maximum here

    setPriceMCError(null); // clear error if present
    return true;
  }

  const onInputChange = (event) => {
    switch (event.target.id) {
      case "priceMC":
        let currentInput = event.target.value;
        if (currentInput.length > 1) {
          currentInput = currentInput.replace(/^0+/, '') // remove any leading zeroes present
          if (currentInput.length === 0) { // if removing leading zeroes results in an empty string, set it to one "0".
            currentInput = "0";
          }
        }
        setPriceMCIsValid(validatePriceMC(currentInput));
        setPriceMC(currentInput);
        break;
      default:
        break;
    }
  }

  const sell = (event) => {

    // Recall: priceMC is validated on input and the sell/list button is only enabled when it's valid

    const price = priceMC * 1000000000;

    if (event.preventDefault) {
      event.preventDefault();
    }

    if (!userReduxStore.braincloudSession.sessionId) {
      console.error("Marketplace sell request ignored. UserReduxStore braincloudSession not found.");
      return;
    }

    const sessionId = userReduxStore.braincloudSession.sessionId;
    const transactionId = asset.id;

    setTransactionPending(true);

    // Simple POST request with a JSON body using fetch
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        sessionId: sessionId,
        petId: transactionId,
        price: price
      })
    };

    let apiEndpointURL = "";
    switch (process.env.REACT_APP_ENV) {
      case "staging":
        apiEndpointURL = "https://cf35m63tng.execute-api.us-east-1.amazonaws.com/test/marketplace/sell";
        break;
      default:
        apiEndpointURL = "https://q645yqsbml.execute-api.us-east-1.amazonaws.com/prod/marketplace/sell";
        break;
    }

    fetch(apiEndpointURL, requestOptions)
      .then(response => response.json())
      .then(data => {
        setTransactionPending(false);
        const success = data.response && data.response.success ? true : false;
        if (success) {
          setTransactionComplete(true);
        } else {
          setTransactionErrorMessage("Error: " + (data.response && data.response.errorMessage ? data.response.errorMessage : "Unknown error."));
        }
      });
  };
    
  if (transactionErrorMessage) {
    return (
      <>
      <div className="marketplaceModal">
        <p>
          {transactionErrorMessage}
        </p>
        <div className="actions">
          <button className="cancel" onClick={props.onDismiss}>Close</button>
        </div>
      </div>
      </>
    )
  }
  if (transactionComplete) {
    return (
      <>
      <div className="marketplaceModal">
        <p>
          Listed successfully!
        </p>
        <div className="actions">
          <button className="buy" onClick={props.onSuccess}>Close</button>
        </div>
      </div>
      </>
    )
  }

  let growToFitSource = "8888"; // Using '8's as spacers
  if (priceMC && (priceMC.length > growToFitSource.length)) {
    growToFitSource = "";
    while (growToFitSource.length < priceMC.length) {
      growToFitSource += "8";
    }
  }

  return (
    <>
    <HeaderActivityIndicator isLoading={transactionPending} />
    <form onSubmit={sell} className="marketplaceModal transactionsForm">{/* using form+onSubmit to enable 'enter' key submissions */}
      <div>
        Enter the price in Magmic Coins below:
      </div>
      <div className="inputs">
        <img className="currency" src={imageMagmicCoin} />&nbsp;
        <div className="growToFitWrapper">{/* wrapper div to grow as priceMC gets larger */}
          <span className="growToFitSource">{growToFitSource}</span>
          {/* input is positioned absolute to parent div in order to enable grow-to-fit*/}
          <input id="priceMC" className="growToFitInput" type="text" placeholder="price" value={priceMC} onChange={onInputChange} /* Disable autocomplete: */ autoComplete="new-password" name="priceMC" />
        </div>
        {priceMCError ?
          <div className="errorMessage">{priceMCError}</div>
        :
          null
        }
      </div>
      <div className="actions">
        <button disabled={transactionPending} className="cancel" onClick={(event) => {
          event.preventDefault();
          props.onDismiss();
        }}>
          Cancel
        </button>
        <button disabled={transactionPending || !priceMCIsValid} type="submit" className="buy">{priceMCIsValid ? 
          "List For " + priceMC
        :
          "List"
        }</button>
      </div>
    </form>
    </>
  )
}

